import { manageAPI } from "./index.js";

const unwrap = (body) => body?.data ?? body;

export const getProductTags = async () => {
  return unwrap((await manageAPI.get("merchant/admin/product-tags")).data);
};

export const createProductTag = async (data) => {
  return unwrap((await manageAPI.post("merchant/admin/product-tags", data)).data);
};

export const updateProductTag = async (id, data) => {
  return unwrap(
    (await manageAPI.put(`merchant/admin/product-tags/${encodeURIComponent(id)}`, data)).data
  );
};

export const deleteProductTag = async (id) => {
  return unwrap(
    (await manageAPI.delete(`merchant/admin/product-tags/${encodeURIComponent(id)}`)).data
  );
};

export const previewProductTagScan = async (id, { reverify = false } = {}) => {
  const qs = reverify ? "?reverify=1" : "";
  return unwrap(
    (await manageAPI.get(
      `merchant/admin/product-tags/${encodeURIComponent(id)}/scan-preview${qs}`
    )).data
  );
};

export const enqueueProductTagScan = async (id, { reverify = false } = {}) => {
  return unwrap(
    (await manageAPI.post(`merchant/admin/product-tags/${encodeURIComponent(id)}/scan`, {
      reverify,
    })).data
  );
};

export const getProductTagScanJob = async (jobId) => {
  return unwrap(
    (await manageAPI.get(
      `merchant/admin/product-tags/scan-jobs/${encodeURIComponent(jobId)}`
    )).data
  );
};

export const listProductTagScanJobs = async ({ tag_id, status, limit } = {}) => {
  const params = new URLSearchParams();
  if (tag_id) params.set("tag_id", tag_id);
  if (status) params.set("status", status);
  if (limit) params.set("limit", String(limit));
  const qs = params.toString();
  return unwrap(
    (await manageAPI.get(
      `merchant/admin/product-tags/scan-jobs${qs ? `?${qs}` : ""}`
    )).data
  );
};
